



























import format from 'date-fns/format';
import Vue from 'vue';

export default Vue.extend({
	name: 'NotibarVue',

	computed: {
		time(): string {
			return format(new Date(), 'h:mm a');
		},

		batteryRate(): number {
			return Math.floor(Math.random() * 100);
		},
	},
});
